<template>
  <div class="custom-enum-state-row">
    <div class="label-column truncate">
      {{ customEnumState.label }}
    </div>
    <div valign="middle">
      <el-select
        :value="customEnumState.value"
        placeholder="Select"
        size="small"
        @input="id => selectValue(id)"
      >
        <el-option
          v-for="item in customEnumState.values.filter(v => !v.isNew)"
          :key="item.id"
          :label="item.label"
          :value="item.id"
        />
      </el-select>
    </div>
    <div>
      <el-popover
        v-model="editPopoverVisible"
        placement="left"
        trigger="manual"
        :append-to-body="true"
      >
        <custom-enum-state-editor
          :case-conf="caseConf"
          :custom-enum-state="customEnumState"
          :readonly="readonly"
          @apply="customEnumState => applyEdit(customEnumState)"
          @cancel="cancelEdit"
        />
        <el-button slot="reference" size="small" icon="more" @click="editPopoverVisible = true" />
      </el-popover>
    </div>
    <div>
      <el-button
        :disabled="readonly"
        icon="delete"
        size="small"
        @click="remove"
      />
    </div>
  </div>
</template>

<script>
import CustomEnumStateEditor from './CustomEnumStateEditor.vue';
import scopeMixins from '../utils/ScopeMixins';

export default {
  name: 'custom-enum-state-row',
  components: {
    CustomEnumStateEditor
  },
  mixins: [ scopeMixins ],
  props: {
    caseConf: {
      type: Object,
      default: () => {}
    },
    customEnumState: {
      type: Object,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      editPopoverVisible: false,
    }
  },
  methods: {
    selectValue(value) {
      this.customEnumState.value = value;
      this.$emit('update', this.customEnumState);
    },
    selectScope(scope) {
      this.customEnumState.scope = scope;
      this.$emit('update', this.customEnumState);
    },
    applyEdit(customEnumState) {
      this.editPopoverVisible = false;
      this.$emit('apply', customEnumState);
    },
    cancelEdit() {
      this.editPopoverVisible = false;
    },
    remove() {
      this.$emit('remove', this.customEnumState);
    },
  }
}
</script>

<style scoped>
.custom-enum-state-row {
  display: grid;
  grid-template-columns: 1fr auto auto auto;
  grid-gap: 4px;
  align-items: center;
  margin-left: 12px;
  margin-bottom: 8px;
  color: white;
}

.label-column {
  cursor: pointer;
  padding-right: 8px;
}

.truncate {
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>